// src/pages/DoctorsOverview/components/DoctorTable.js
import React, { useEffect } from "react";
import { Table, Button, Space, Modal, message } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  selectDoctorsList,
  selectIsDoctorModalOpen,
} from "../DoctorsSelectors";
import { fetchDoctorsList, removeDoctor } from "../DoctorsThunk";
import { openDoctorModal } from "../DoctorsSlice";
import DoctorModal from "./DoctorModal";

const { confirm } = Modal;

const DoctorTable = () => {
  const dispatch = useDispatch();
  const doctors = useSelector(selectDoctorsList);
  const isModalOpen = useSelector(selectIsDoctorModalOpen);

  useEffect(() => {
    dispatch(fetchDoctorsList());
  }, [dispatch]);

  const handleEdit = (record) => {
    dispatch(openDoctorModal(record));
  };

  const handleDelete = (record) => {
    confirm({
      title: "Are you sure delete this doctor?",
      onOk: async () => {
        try {
          await dispatch(removeDoctor(record.doctor_id)).unwrap();
          message.success("Doctor deleted successfully");
          dispatch(fetchDoctorsList());
        } catch (err) {
          message.error(err?.message || "Delete failed");
        }
      },
    });
  };

  const columns = [
    { title: "No.", key: "idx", render: (_, __, idx) => idx + 1 },
    { title: "Doctor", dataIndex: "doctor_name", key: "doctor_name" },
    { title: "Clinic", dataIndex: "clinic_name", key: "clinic_name" },
    { title: "Email", dataIndex: "email_address", key: "email_address" },
    { title: "Last Billed Date", dataIndex: "last_billed_date", key: "last_billed_date" },
    { title: "Total", dataIndex: "total_sales_amount", key: "total_sales_amount", render : (v)=>Number(v).toFixed(2) },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)}>           
          </Button>
          <Button type="link" icon={<DeleteOutlined />} danger onClick={() => handleDelete(record)}>
           </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <Button type="primary" onClick={() => dispatch(openDoctorModal(null))}>
          + New Doctor
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={doctors}
        rowKey={(r) => r.doctor_id || Math.random()}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }}
      />

      {isModalOpen && <DoctorModal />}
    </div>
  );
};

export default DoctorTable;
